import { SearchOperationBuilder, SearchParam } from 'wherecomposer/dist/SearchParam';
import { ConditionCreator } from 'wherecomposer/dist/ConditionCreator';
import { createBranchConfigurator, getBranch, deleteBranch, updateBranch } from '../graphql/branch';
import { Auth, API, graphqlOperation, Amplify } from 'aws-amplify';

let branchAppSyncUrl = process.env.REACT_APP_BRANCH_APPSYNC_URL;
let branchApiKey = process.env.REACT_APP_BRANCH_API_KEY;

const getLocation = async () => {
    let langugeGuid = localStorage.getItem('languageGuid');
    let languageCode = localStorage.getItem("languageCode");

    try {
        let lstobjSearchParam = [];
        let objSearchParam1 = new SearchParam();
        objSearchParam1.searchParamCreate("LanguageGuid", "Guid", langugeGuid, SearchOperationBuilder.create(true, false, false));
        lstobjSearchParam.push(objSearchParam1);

        let objSearchParam2 = new SearchParam();
        objSearchParam2.searchParamCreate("IsBranch", "Boolean", true, SearchOperationBuilder.create(true, false, false));
        lstobjSearchParam.push(objSearchParam2);

        let objCreator = new ConditionCreator();
        let objWhere = objCreator.getSearchCondition(lstobjSearchParam);

        const currentSession = await Auth.currentSession();

        const locationConfig = {
            API: {
                'graphql_endpoint': branchAppSyncUrl,
                graphql_headers: async () => {
                    return {
                        'Authorization': currentSession.getIdToken().getJwtToken(),
                        'language': languageCode,
                        'x-api-key': branchApiKey
                    };
                }
            }
        }

        Amplify.configure(locationConfig);

        return await API.graphql(graphqlOperation(getBranch, { OperationList: objWhere.toJsonString() }));
    } catch (error) {
        console.log('getBranch error', error);
    }
}

const getLocationByGroupGuid = async (locationGroupGuid) => {
    let languageCode = localStorage.getItem("languageCode");

    try {
        let lstobjSearchParam = [];
        let objSearchParam1 = new SearchParam();
        objSearchParam1.searchParamCreate("GroupGuid", "Guid", locationGroupGuid, SearchOperationBuilder.create(true, false, false));
        lstobjSearchParam.push(objSearchParam1);

        let objCreator = new ConditionCreator();
        let objWhere = objCreator.getSearchCondition(lstobjSearchParam);

        const locationConfig = {
            API: {
                'graphql_endpoint': branchAppSyncUrl,
                graphql_headers: async () => {
                    const currentSession = await Auth.currentSession();
                    return {
                        'Authorization': currentSession.getIdToken().getJwtToken(),
                        'language': languageCode,
                        'x-api-key': branchApiKey
                    };
                }
            }
        }

        Amplify.configure(locationConfig);

        return await API.graphql(graphqlOperation(getBranch, { OperationList: objWhere.toJsonString() }));
    } catch (error) {
        console.log('getBranch error', error);
    }
}

const deleteLocation = async (deleteDataArray) => {
    let langugeGuid = localStorage.getItem('languageGuid');
    let languageCode = localStorage.getItem("languageCode");

    try {
        Amplify.configure({
            API: {
                graphql_endpoint: branchAppSyncUrl,
                graphql_headers: async () => {
                    const currentSession = await Auth.currentSession();
                    return {
                        Authorization: currentSession.getIdToken().getJwtToken(),
                        LanguageGuid: langugeGuid,
                        language: languageCode,
                        'x-api-key': branchApiKey,
                    };
                }
            },
        });

        return await API.graphql(graphqlOperation(deleteBranch, { data: deleteDataArray }));
    } catch (error) {
        console.log('getBranch error', error);
    }
}

const createLocation = async (createDataArray) => {
    let langugeGuid = localStorage.getItem('languageGuid');
    let languageCode = localStorage.getItem("languageCode");

    Amplify.configure({
        API: {
            graphql_endpoint: branchAppSyncUrl,
            graphql_headers: async () => {
                const currentSession = await Auth.currentSession();
                return {
                    Authorization: currentSession.getIdToken().getJwtToken(),
                    LanguageGuid: langugeGuid,
                    language: languageCode,
                    'x-api-key': branchApiKey,
                };
            }
        },
    });

    return await API.graphql(graphqlOperation(createBranchConfigurator, { data: createDataArray }));
}

const updateLocation = async (editDataArray) => {
    let langugeGuid = localStorage.getItem('languageGuid');
    let languageCode = localStorage.getItem("languageCode");

    console.log(editDataArray, langugeGuid, languageCode)

    Amplify.configure({
        API: {
            graphql_endpoint: branchAppSyncUrl,
            graphql_headers: async () => {
                const currentSession = await Auth.currentSession();
                return {
                    Authorization: currentSession.getIdToken().getJwtToken(),
                    LanguageGuid: langugeGuid,
                    language: languageCode,
                    'x-api-key': branchApiKey,
                };
            }
        },
    });

    return await API.graphql(graphqlOperation(updateBranch, { data: editDataArray }));
}

export {
    getLocation,
    deleteLocation,
    createLocation,
    updateLocation,
    getLocationByGroupGuid
}